function inferDefaultOrigin() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") return "http://localhost:3003";
  }
  return process.env.NODE_ENV === "development" ? "http://localhost:3003" : "https://api.mhusaevents.com";
}

const DEFAULT_API_ORIGIN = inferDefaultOrigin();

const API_ORIGIN = process.env.REACT_APP_API_ORIGIN || DEFAULT_API_ORIGIN;
const API_BASE_PATH = "/v1/mhdc";

function buildUrl(pathname) {
  return new URL(`${API_BASE_PATH}${pathname}`, API_ORIGIN).toString();
}

async function readJson(response) {
  const text = await response.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

async function requestJson(url, options) {
  let response;
  try {
    response = await fetch(url, options);
  } catch (err) {
    const message =
      err instanceof TypeError ? "Network error: unable to reach the RSVP server." : "Request failed.";
    throw new Error(message);
  }
  const data = await readJson(response);

  if (!response.ok) {
    const message = data?.message || `Request failed (${response.status})`;
    const error = new Error(message);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}

export async function submitChicagoDCRsvp(payload) {
  return requestJson(buildUrl("/rsvpChicagoDC"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export async function searchChicagoDCRsvp(params = {}) {
  const url = new URL(buildUrl("/searchChicagoDCRSVP"));
  Object.entries(params).forEach(([key, value]) => {
    const trimmed = typeof value === "string" ? value.trim() : value;
    if (trimmed === "" || trimmed == null) return;
    url.searchParams.set(key, String(trimmed));
  });
  return requestJson(url.toString(), { method: "GET" });
}

export async function getAllChicagoDCRsvp() {
  return requestJson(buildUrl("/getAllChicagoDCRSVP"), { method: "GET" });
}
